"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Prefixes_1 = __importDefault(require("../../shared/models/Prefixes"));
class Perms {
    static Network_View = 'net';
    static Network_Add = 'net.add';
    static Network_Edit = 'net.edt';
    static Network_Delete = 'net.del';
    static NetworkList_View = 'net.lst';
    static ServicingC1_View = 'sc1';
    static ServicingC1_Add = 'sc1.add';
    static ServicingC1_Edit = 'sc1.edt';
    static ServicingC1_Delete = 'sc1.del';
    static C2_View = 'c2';
    static C2_Digest = 'c2.dgt';
    static C2_Add = 'c2.add';
    static C2_Edit = 'c2.edt';
    static C2_Delete = 'c2.del';
    static User_View = 'usr';
    static User_Edit = 'usr.edt';
    static Role_View = 'rol';
    static Role_Add = 'rol.add';
    static Role_Edit = 'rol.edt';
    static Role_Delete = 'rol.del';
    static Order_View = 'ord';
    static Order_Edit = 'ord.edt';
    static Receiver_View = 'rcv';
    static Adjustment_View = 'adj';
    static Assembly_View = 'asm';
    static Inventory_View = 'inv';
    static OrderRouting_View = 'ort';
}
class FplPermissions {
    // administrative permissions
    static Admin_Network_Add = Prefixes_1.default.AdminScope + Perms.Network_Add;
    static Admin_Network_View = Prefixes_1.default.AdminScope + Perms.Network_View;
    static Admin_Network_Delete = Prefixes_1.default.AdminScope + Perms.Network_Delete;
    static Admin_NetworkList_View = Prefixes_1.default.AdminScope + Perms.NetworkList_View;
    // Base permissions
    //-----------------
    // network permissions
    // View network
    static Base_Network_View = Prefixes_1.default.BaseScope + Perms.Network_View;
    // Edit network
    static Base_Network_Edit = Prefixes_1.default.BaseScope + Perms.Network_Edit;
    // servicing c1 permissions
    // View servicing c1(s)
    static Base_ServicingC1_View = Prefixes_1.default.BaseScope + Perms.ServicingC1_View;
    // Add servicing c1
    static Base_ServicingC1_Add = Prefixes_1.default.BaseScope + Perms.ServicingC1_Add;
    // Edit servicing c1
    static Base_ServicingC1_Edit = Prefixes_1.default.BaseScope + Perms.ServicingC1_Edit;
    // Delete servicing c1
    static Base_ServicingC1_Delete = Prefixes_1.default.BaseScope + Perms.ServicingC1_Delete;
    // c2 permissions
    // View c2(s)
    static Base_C2_View = Prefixes_1.default.BaseScope + Perms.C2_View;
    // View c2 digest
    static Base_C2_Digest = Prefixes_1.default.BaseScope + Perms.C2_Digest;
    // Add c2
    static Base_C2_Add = Prefixes_1.default.BaseScope + Perms.C2_Add;
    // Edit c2
    static Base_C2_Edit = Prefixes_1.default.BaseScope + Perms.C2_Edit;
    // Delete c2
    static Base_C2_Delete = Prefixes_1.default.BaseScope + Perms.C2_Delete;
    // user permissions
    // View user(s)
    static Base_User_View = Prefixes_1.default.BaseScope + Perms.User_View;
    // Edit user
    static Base_User_Edit = Prefixes_1.default.BaseScope + Perms.User_Edit;
    // role permissions
    // View role(s)
    static Base_Role_View = Prefixes_1.default.BaseScope + Perms.Role_View;
    // Add role
    static Base_Role_Add = Prefixes_1.default.BaseScope + Perms.Role_Add;
    // Edit role
    static Base_Role_Edit = Prefixes_1.default.BaseScope + Perms.Role_Edit;
    // Delete role
    static Base_Role_Delete = Prefixes_1.default.BaseScope + Perms.Role_Delete;
    // order permissions
    // View order(s)
    static Base_Order_View = Prefixes_1.default.BaseScope + Perms.Order_View;
    static Base_Order_Edit = Prefixes_1.default.BaseScope + Perms.Order_Edit;
    static Base_Receiver_View = Prefixes_1.default.BaseScope + Perms.Receiver_View;
    static Base_Adjustment_View = Prefixes_1.default.BaseScope + Perms.Adjustment_View;
    static Base_Assembly_View = Prefixes_1.default.BaseScope + Perms.Assembly_View;
    static Base_Inventory_View = Prefixes_1.default.BaseScope + Perms.Inventory_View;
    static Base_OrderRouting_View = Prefixes_1.default.BaseScope + Perms.OrderRouting_View;
    // cross org permissions
    //----------------------
    // company permissions
    // View Other Networks
    static CrossOrg_Network_View = Prefixes_1.default.CrossOrgScope + Perms.Network_View;
    // Edit Other Networks
    static CrossOrg_Network_Edit = Prefixes_1.default.CrossOrgScope + Perms.Network_Edit;
    // servicing c1 permissions
    // View servicing c1(s) of Other Networks
    static CrossOrg_ServicingC1_View = Prefixes_1.default.CrossOrgScope + Perms.ServicingC1_View;
    // Add servicing c1 of Other Networks
    static CrossOrg_ServicingC1_Add = Prefixes_1.default.CrossOrgScope + Perms.ServicingC1_Add;
    // Edit servicing c1 of Other Networks
    static CrossOrg_ServicingC1_Edit = Prefixes_1.default.CrossOrgScope + Perms.ServicingC1_Edit;
    // Delete servicing c1 of Other Networks
    static CrossOrg_ServicingC1_Delete = Prefixes_1.default.CrossOrgScope + Perms.ServicingC1_Delete;
    // c2 permissions
    // View c2(s) of Other Networks
    static CrossOrg_C2_View = Prefixes_1.default.CrossOrgScope + Perms.C2_View;
    // View c2 digest of Other Networks
    static CrossOrg_C2_Digest = Prefixes_1.default.CrossOrgScope + Perms.C2_Digest;
    // Add c2 of Other Networks
    static CrossOrg_C2_Add = Prefixes_1.default.CrossOrgScope + Perms.C2_Add;
    // Edit c2 of Other Networks
    static CrossOrg_C2_Edit = Prefixes_1.default.CrossOrgScope + Perms.C2_Edit;
    // Delete c2 of Other Networks
    static CrossOrg_C2_Delete = Prefixes_1.default.CrossOrgScope + Perms.C2_Delete;
    // user permissions
    // View Users of Other Networks
    static CrossOrg_User_View = Prefixes_1.default.CrossOrgScope + Perms.User_View;
    // Edit Users of Other Networks
    static CrossOrg_User_Edit = Prefixes_1.default.CrossOrgScope + Perms.User_Edit;
    // role permissions
    // View Roles of Other Networks
    static CrossOrg_Role_View = Prefixes_1.default.CrossOrgScope + Perms.Role_View;
    // Add Roles to Other Networks
    static CrossOrg_Role_Add = Prefixes_1.default.CrossOrgScope + Perms.Role_Add;
    // Edit Roles of Other Networks
    static CrossOrg_Role_Edit = Prefixes_1.default.CrossOrgScope + Perms.Role_Edit;
    // Delete Roles from Other Networks
    static CrossOrg_Role_Delete = Prefixes_1.default.CrossOrgScope + Perms.Role_Delete;
    // order permissions
    // View order(s) of Other Networks
    static CrossOrg_Order_View = Prefixes_1.default.CrossOrgScope + Perms.Order_View;
    static CrossOrg_Order_Edit = Prefixes_1.default.CrossOrgScope + Perms.Order_Edit;
    static CrossOrg_Receiver_View = Prefixes_1.default.CrossOrgScope + Perms.Receiver_View;
    static CrossOrg_Adjustment_View = Prefixes_1.default.CrossOrgScope + Perms.Adjustment_View;
    static CrossOrg_Assembly_View = Prefixes_1.default.CrossOrgScope + Perms.Assembly_View;
    static CrossOrg_Inventory_View = Prefixes_1.default.CrossOrgScope + Perms.Inventory_View;
    static CrossOrg_OrderRouting_View = Prefixes_1.default.CrossOrgScope + Perms.OrderRouting_View;
}
exports.default = FplPermissions;
